// Utility to strip HTML and get preview with line breaks shown as arrows
export function getTextPreview(html) {
  // Replace block-level tags with newlines, then strip tags
  const blockTags = /<\s*(p|div|li|br|h[1-6]|tr|td|th)[^>]*>/gi;
  const textWithNewlines = html.replace(blockTags, "\n");
  const text = textWithNewlines.replace(/<[^>]+>/g, "").trim();

  // Decode HTML entities (e.g., &gt; -> >, &lt; -> <, &amp; -> &)
  const temp = document.createElement("textarea");
  temp.innerHTML = text;
  const decodedText = temp.value;

  const lines = decodedText
    .split(/\r?\n|\r/)
    .map((l) => l.trim())
    .filter(Boolean);
  return lines.join(" → ");
}
